import React from "react";

export const NavbarSocialComponent = ({ bgicon, link, iconName, icon }) => {
  return (
    <li
      className={`w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 ${bgicon} `}
    >
      <a
        className="flex justify-between items-center w-full text-gray-300"
        href={link}
      >
        {iconName}
        {icon}
      </a>
    </li>
  );
};
